export default __webpack_public_path__ + "static/media/watersporwinkel.a90400b6.svg";